import { Dispatch } from "redux";

import {
  generateItemActions,
  generateGenerateEditActions,
  generateItemsReducer,
  itemFromStore,

  generateItemListAndActionsFromStore,

  generateItemAndActionsFromStore,
} from "./item";

const itemType = "activity";
const endpoint = "activities/";

export const activitiesReducer = generateItemsReducer<ActivitySnakeModel, VersionLocalData>(itemType);

export const activityAndActionsFromStore = generateItemAndActionsFromStore<ActivitySnakeModel, VersionLocalData, ItemEditActions<ActivityContent>>(
  itemType,
  endpoint,
  generateGenerateEditActions<ActivitySnakeModel, VersionLocalData, ActivityContent>(
    (activity) => activity._editData.content || ("lastSyncedAt" in activity && activity.content) || undefined,
    (content) => ({content: content}),
  ),
);

export const activityListAndActionsFromStore = generateItemListAndActionsFromStore(itemType, activityAndActionsFromStore);
